export default __webpack_public_path__ + "static/media/ic_invoice_primary.bf5c0a44.svg";